import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Grid,
  Box,
  TextField as Input,
  CircularProgress,
  RadioGroup,
} from '@material-ui/core'

//property icons
import apart_blue from "../../static/images/apartment_blue.svg";
import apart_orange from "../../static/images/apartment_orange.svg";
import detached_blue from "../../static/images/detached_blue.svg";
import detached_orange from "../../static/images/detached_orange.svg";
import duplex_blue from "../../static/images/duplex_blue.svg";
import duplex_orange from "../../static/images/duplex_orange.svg";
import fourplex_blue from "../../static/images/fourplex_blue.svg";
import fourplex_orange from "../../static/images/fourplex_orange.svg";
import semi_detached_blue from "../../static/images/semi_detached_blue.svg";
import semi_detached_orange from "../../static/images/semi_detached_orange.svg";
import townhouse_blue from "../../static/images/townhouse_blue.svg";
import townhouse_orange from "../../static/images/townhouse_orange.svg";
import triplex_blue from "../../static/images/triplex_blue.svg";
import triplex_orange from "../../static/images/triplex_orange.svg";
import Profile from "../../static/images/default-profile.png";
import Widget from '../../components/Widget/Widget'
import { Typography } from '../../components/Wrappers/Wrappers'
import useStyles from "./styles";

//context
import {
  useUsersState,
  getUserProfile
} from "../../context/UsersContext";

import moment from 'moment';
import "../../static/css/global.css"
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';

//User details component
const UserDetails = props => {
  const classes = useStyles();
  const context = useUsersState();

  var [profile, setBackUserProfile] = useState({});
  var [Properties, setproperties] = useState({});

  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = React.useState('1');


  //React hook which calls when page loads
  useEffect(() => {
    if (props.location.state && props.location.state.user_id) {
      getUserProfile(context.setUserProfile, { user_id: props.location.state.user_id });
    }
  }, []); // eslint-disable-line

  //React hook which calls when context value change
  useEffect(() => {
    setBackUserProfile(context.profile.profile);
    setproperties(context.profile.profile.data)
    setIsLoading(false)
  }, [context]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Managing_partner = (Property_type) => {
    switch (Property_type.toLowerCase()) {

      case "single-family detached":
        return (<img src={detached_orange} alt="loading" className='Propertyicons' />)

      case "semi-detached":
        return (<img src={semi_detached_orange} alt="loading" className='Propertyicons' />)

      case "row/townhouse":
        return (<img src={townhouse_orange} alt="loading" className='Propertyicons' />)

      case "condo/apartment":
        return (<img src={apart_orange} alt="loading" className='Propertyicons' />)

      case "single-family":
        return (<img src={apart_orange} alt="loading" className='Propertyicons' />)

      case "duplex":
        return (<img src={duplex_orange} alt="loading" className='Propertyicons' />)

      case "triplex":
        return (<img src={triplex_orange} alt="loading" className='Propertyicons' />)

      case "fourplex":
        return (<img src={fourplex_orange} alt="loading" className='Propertyicons' />)

      case "multiplex":
        return (<img src={apart_orange} alt="loading" className='Propertyicons' />)

      default:
        return "";
    }
  };

  const Money_partner = (Property_type) => {

    switch (Property_type.toLowerCase()) {
      case "single-family detached":
        return (<img src={detached_blue} alt="loading" className='Propertyicons' />)

      case "semi-detached":
        return (<img src={semi_detached_blue} alt="loading" className='Propertyicons' />)

      case "row/townhouse":
        return (<img src={townhouse_blue} alt="loading" className='Propertyicons' />)

      case "condo/apartment":
        return (<img src={apart_blue} alt="loading" className='Propertyicons' />)

      case "single-family":
        return (<img src={apart_blue} alt="loading" className='Propertyicons' />)

      case "duplex":
        return (<img src={duplex_blue} alt="loading" className='Propertyicons' />)

      case "triplex":
        return (<img src={triplex_blue} alt="loading" className='Propertyicons' />)

      case "fourplex":
        return (<img src={fourplex_blue} alt="loading" className='Propertyicons' />)

      case "multiplex":
        return (<img src={apart_blue} alt="loading" className='Propertyicons' />)

      default:
        return ""
    }
  };

  return (
    <Grid container spacing={3}>
      <span className={classes.mainPageTitle}><b>User Details</b></span>
      {(!context.profile.isLoaded || !profile.data || isLoading) ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100vw"}
          height={"calc(100vh - 200px)"}
        >
          <CircularProgress size={50} />
        </Box>
      ) : (
        <>
          <Widget className={classes.boxContainer} noBodyPadding>
            <Box style={{ padding: '25px' }}>
              <Grid container spacing={2}>
                <Grid xs={2} sm={4} md={4}>
                  <Typography
                    variant={'subtitle1'}
                    color={'primary'}
                  >Profile Picture</Typography>
                  {profile.data.image === null ? <img style={{ borderRadius: '50%', height: "200px" }} src={Profile} alt="" /> :
                    <img src={profile.data.image} className={classes.profilePictureUserdetail} alt='profile' />}
                </Grid>
                <Grid xs={10} sm={8} md={8} >
                  <Typography
                    variant={'subtitle1'}
                    color={'primary'}
                    style={{ marginBottom: '10px' }}
                  >About Me</Typography>
                  <Input
                    margin="dense"
                    variant="outlined"
                    InputProps={{
                      disabled: true,
                      classes: {
                        input: classes.Input
                      }
                    }}
                    style={{ margin: '0px' }}
                    value={profile.data.about_us}
                    multiline
                    fullWidth
                    rows={9}
                  />
                </Grid>
              </Grid>
            </Box>
          </Widget>
          <Widget className={classes.boxContainer} noBodyPadding>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={value} >
                {/* //f1981c */}
                <Box sx={{ borderBottom: 1, borderColor: '#5F8275' }}>
                  {/* //FA991C */}
                  <TabList onChange={handleChange} aria-label="lab API tabs example" TabIndicatorProps={{ style: { background: '#2F695F' } }}>
                    <Tab label="General Info" value="1"
                      style={{ color: "#5F8275" }}
                      in />
                    <Tab label="Subscription" value="2"
                      style={{ color: "#5F8275" }}
                    />
                  </TabList>
                </Box>
                <TabPanel value="1" style={{ padding: "4px" }}>
                  <Widget className={classes.boxContainer} noBodyPadding>
                    <Box style={{ padding: '16px' }} className='basicInfo'>
                      <Box className={classes.basicInfoContainer}>
                        <Grid md={4} sm={4} xs={4}>
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Firstname</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={profile.data.first_name}
                          />
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Email-id</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={profile.data.email}
                          />
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Gender</Typography>
                          <RadioGroup
                            aria-label="Gender"
                            name="gender1"
                            className={classes.group}
                            value={profile.data.gender}
                          >
                            <span className='genderValue'>{profile.data.gender}</span>
                            {/* <FormControlLabel classes={{ label: classes.radioLabels }} value="male" disabled control={<Radio />} label="Male" style={{ fontSize: '13px' }} />
                                  <FormControlLabel classes={{ label: classes.radioLabels }} value="female" disabled control={<Radio />} label="Female" style={{ fontSize: '13px' }} /> */}
                          </RadioGroup>
                        </Grid>
                        <Grid md={4} sm={4} xs={4}>
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Lastname</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={profile.data.last_name}
                          />
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Phone Number</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={profile.data.phone}
                          />
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Country</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={profile.data.country_name}
                          />
                        </Grid>
                        <Grid md={4} sm={4} xs={4}>
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Username</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={profile.data.username}
                          />
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >Date of Birth</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={moment(profile.data.date_of_birth).format("DD-M-YYYY")}
                          />
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}
                          >City</Typography>
                          <Input
                            margin="dense"
                            variant="outlined"
                            InputProps={{
                              disabled: true,
                              classes: {
                                input: classes.Input
                              }
                            }}
                            className={classes.inputBox}
                            value={profile.data.city_name}
                          />
                        </Grid>
                      </Box>
                    </Box>
                  </Widget>
                  <Grid style={{ width: '100%' }} >
                    <Widget className={classes.boxContainer} style={{ height: '100%' }} noBodyPadding>
                      <Box style={{ padding: '20px', marginBottom: '10px' }}>
                        <Typography
                          variant={'subtitle1'}
                          color={'primary'}
                        >My Properties</Typography>
                        <Box >
                          <Typography
                            variant={'subtitle1'}
                            color={'black'}
                            className={classes.formLabels}

                          >Total Properties : {profile.data.all_properties.length} </Typography>
                        </Box>
                        <Grid container spacing={3}>
                          {Properties.all_properties && Properties.all_properties.length > 0 && Properties.all_properties.map((p, index) => {
                            return (
                              <Grid md={4}
                                key={index}
                                className={classes.PropertyItemGrid}
                              >
                                <Widget bodyClass={classes.PropertyContainer}>
                                  <Typography
                                    color="text"
                                    colorBrightness={"secondary"}
                                    style={{ fontSize: '14px' }}
                                  >
                                    <div className='user-detail-list'>
                                      <div className="property-icons d-flex justify-content-center">
                                        {p.user_id === props.location.state.user_id ? Managing_partner(p.property_type) : Money_partner(p.property_type)}
                                      </div>
                                      <div className='property-address'>
                                        {` ${p.address}, ${p.city}, ${p.state} ,${p.state_abbreviation} ,${p.country}`}
                                      </div>
                                    </div>
                                  </Typography>
                                </Widget>
                              </Grid>
                            )
                          })}
                        </Grid>
                      </Box>
                    </Widget>
                  </Grid>
                </TabPanel>
                <TabPanel value="2" className='pe-4'>Subscription Data</TabPanel>
              </TabContext>
            </Box>
          </Widget>
        </>
      )}
    </Grid>
  )
}

export default withRouter(UserDetails)
